import { apiClient } from '@/core/apiClient';
import { RescuedAnimal, RescuedAnimalsListParams, RescuedAnimalStatusCode } from './types';

export const rescuedAnimalsApi = {
  list: async (params?: RescuedAnimalsListParams) => {
    const response = await apiClient.get('/rescued-animals', { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await apiClient.get(`/rescued-animals/${id}`);
    return response.data;
  },

  createFull: async (rescuedAnimal: Partial<RescuedAnimal>, photos?: Array<{url: string; isPrimary?: boolean}>) => {
    const response = await apiClient.post('/rescued-animals/full', { rescuedAnimal, photos });
    return response.data;
  },

  updateFull: async (
    id: number,
    rescuedAnimal?: Partial<RescuedAnimal>,
    photos?: Array<{url: string; isPrimary?: boolean}>,
  ) => {
    const response = await apiClient.patch(`/rescued-animals/full/${id}`, { rescuedAnimal, photos });
    return response.data;
  },

  update: async (id: number, rescuedAnimal: Partial<RescuedAnimal>) => {
    await apiClient.patch(`/rescued-animals/${id}`, rescuedAnimal);
  },

  setStatus: async (id: number, statusCode: RescuedAnimalStatusCode) => {
    await apiClient.post(`/rescued-animals/${id}/status`, { statusCode });
  },

  delete: async (id: number) => {
    await apiClient.delete(`/rescued-animals/${id}`);
  },

  // Photos
  uploadPhotos: async (rescuedAnimalId: number, files: File[]) => {
    const fd = new FormData();
    files.forEach((f) => fd.append('files', f));
    const response = await apiClient.post(`/rescued-animals/${rescuedAnimalId}/photos/upload`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  setPhotoPrimary: async (rescuedAnimalId: number, newPrimaryId: number) => {
    await apiClient.post(`/rescued-animals/${rescuedAnimalId}/photos/set-primary`, { photoId: newPrimaryId });
  },

  deleteAllPhotos: async (rescuedAnimalId: number) => {
    await apiClient.delete(`/rescued-animals/${rescuedAnimalId}/photos`);
  },

  deletePhoto: async (rescuedAnimalId: number, photoId: number) => {
    await apiClient.delete(`/rescued-animals/${rescuedAnimalId}/photos/${photoId}`);
  },
};
